export enum TracciatoDirections {
  horizontal = 0,
  vertical = 1
}

export const TRACCIATO_DIRECTIONS = [
  { value: TracciatoDirections.horizontal, label: 'Orizzontale' },
  { value: TracciatoDirections.vertical, label: 'Verticale' }
];
